<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <v-snackbar v-model="snackbar" top right dark color="green darken-1">
      {{ snackbarMsg }}
    </v-snackbar>

    <StaffNav class="hideOnPrint" />
    <v-row class="hideOnPrint">
      <v-col cols="12" lg="3" xl="2">
        <StaffSide />
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <v-data-table
          :headers="headers"
          :items="tests"
          sort-by="Date"
          sort-desc
          class="elevation-1"
          :loading="isLoading"
          loading-text="Loading Client Tests"
          :search="search"
          height="550"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Client Test</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                clearable
                flat
                solo-inverted
                hide-details
                prepend-inner-icon="search"
                label="search"
                class="desktop"
              ></v-text-field>

              <v-spacer></v-spacer>
              <report-list-actions
                :reportOptions="reportOptions"
                :downloadFilename="reportListFilename"
              ></report-list-actions>
              
              <v-btn
                v-if="!isAuditorRole"
                color="#2b3990"
                class="mb-2 white--text"
                @click="showAdd()"
              >
                <v-icon left>add</v-icon>
                Add Client Test</v-btn
              >
            </v-toolbar>
            <v-text-field
              v-model="search"
              clearable
              flat
              solo-inverted
              hide-details
              prepend-inner-icon="search"
              label="search"
              class="mobile ml-5 mr-5 mb-3 mt-3"
            ></v-text-field>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="viewTest(item)">
              mdi-eye
            </v-icon>
            <v-icon v-if="canDelete" small @click="deleteTest(item)"> mdi-delete </v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn color="#2b3990" class="white--text" @click="getTests()"
              >Reset</v-btn
            >
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <Foot class="hideOnPrint" />
  </div>
</template>
<script>
import axios from "axios";
import StaffNav from "@/components/StaffNav";
import StaffSide from "@/components/StaffSide";
import Foot from "@/components/Footer";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import ReportListActions from '@/components/Report/ReportListActions.vue'

const url = require("../../../client_config/config").url;

export default {
  components: {
    StaffNav,
    StaffSide,
    Foot,
    ReportListActions,
  },
  data: function () {
    return {
      headers: [
        {
          text: "Date",
          align: "start",
          sortable: true,
          value: "Date",
        },
        { text: "Employee Name", value: "Employee.Name" },
        { text: "Client Name", value: "ClientName" },
        { text: "Program", value: "Program" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      e6: 1,
      dialog: false,
      editTest: false,
      newTest: false,
      msg: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      search: "",
      text: "",
      tests: [],
      tempData: [],
      clients: [],
      units: [],
      employeeID: this.$route.params.employeeID,
      titleForm: "New Client Test",
      staffTestID: "",
      newDate: "",
      newClientName: "",
      newProgram: "",
      newConditions: "",
      newFunctions: "",
      newReadPCSP: "",
      newReadCSS: "",
      newG1: "",
      newG1S1: "",
      newG1S2: "",
      newG1S3: "",
      newG1S4: "",
      newG2: "",
      newG2S1: "",
      newG2S2: "",
      newG2S3: "",
      newG2S4: "",
      newG3: "",
      newG3S1: "",
      newG3S2: "",
      newG3S3: "",
      newG3S4: "",
      newG4: "",
      newG4S1: "",
      newG4S2: "",
      newG4S3: "",
      newG4S4: "",
      newStrengths: "",
      newPreferences: "",
      newInterests: "",
      newRecreation: "",
      newFinancial: "",
      newHealthConcerns: "",
      newPrecautions: "",
      newDiet: "",
      newIll: "",
      newEating: "",
      newGoals: "",
      newMed1: "",
      newPurp1: "",
      newSide1: "",
      newMed2: "",
      newPurp2: "",
      newSide2: "",
      newMed3: "",
      newPurp3: "",
      newSide3: "",
      newMed4: "",
      newPurp4: "",
      newSide4: "",
      newMed5: "",
      newPurp5: "",
      newSide5: "",
      newMed6: "",
      newPurp6: "",
      newSide6: "",
      newMed7: "",
      newPurp7: "",
      newSide7: "",
      newMed8: "",
      newPurp8: "",
      newSide8: "",
      newMed9: "",
      newPurp9: "",
      newSide9: "",
      newMed10: "",
      newPurp10: "",
      newSide10: "",
      newMed11: "",
      newPurp11: "",
      newSide11: "",
      newMed12: "",
      newPurp12: "",
      newSide12: "",
      newMed13: "",
      newPurp13: "",
      newSide13: "",
      newMed14: "",
      newPurp14: "",
      newSide14: "",
      newMed15: "",
      newPurp15: "",
      newSide15: "",
      newMed16: "",
      newPurp16: "",
      newSide16: "",
      newMed17: "",
      newPurp17: "",
      newSide17: "",
      newMed18: "",
      newPurp18: "",
      newSide18: "",
      newMed19: "",
      newPurp19: "",
      newSide19: "",
      newMed20: "",
      newPurp20: "",
      newSide20: "",
      newReadRR: "",
      newRights: "",
      newSupervision: "",
      newBCS: "",
      newReadBCS: "",
      newTar1: "",
      newDef1: "",
      newTar2: "",
      newDef2: "",
      newTar3: "",
      newDef3: "",
      newTar4: "",
      newDef4: "",
      newTar5: "",
      newDef5: "",
      newTar6: "",
      newDef6: "",
      newTrig1: "",
      newTrig2: "",
      newTrig3: "",
      newTrig4: "",
      newTrig5: "",
      newTrig6: "",
      newInt1: "",
      newInt2: "",
      newInt3: "",
      newInt4: "",
      newInt5: "",
      newInt6: "",
      newPhase1: "",
      newBehavior1: "",
      newResp1: "",
      newPhase2: "",
      newBehavior2: "",
      newResp2: "",
      newPhase3: "",
      newBehavior3: "",
      newResp3: "",
      newPhase4: "",
      newBehavior4: "",
      newResp4: "",
      newPhase5: "",
      newBehavior5: "",
      newResp5: "",
      newPhase6: "",
      newBehavior6: "",
      newResp6: "",
      newReinforce: "",
      newRelationship: "",
      newRedirection: "",
      newReadCCP: "",
      newRole1: "",
      newName1: "",
      newRole2: "",
      newName2: "",
      newRole3: "",
      newName3: "",
      newRole4: "",
      newName4: "",
      newRole5: "",
      newName5: "",
      newRole6: "",
      newName6: "",
      newRole7: "",
      newName7: "",
      newRole8: "",
      newName8: "",
      newRole9: "",
      newName9: "",
      newRole10: "",
      newName10: "",
      isLoading: true,
      staffName: "",
      item: {},
      debounceTimeout: null,
      draftKey: null,
      snackbar: false,
      snackbarMsg: "",
      userState: localStorage.getItem("userState"),
      userCompanyIds: localStorage.getItem("userCompanies")
        ? JSON.parse(localStorage.getItem("userCompanies"))
        : [],
      userCompany: {},
      basicStaffRole: ["Direct Care Staff", "Assistant Manager", "Shift Lead", "House Manager" ]
    };
    
  },

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },

    employeeName() {
      return this.$store.state.users.user.Name;
    },

    reportOptions() {
      return { 
        query: {
          name: this.employeeName,
        },
        endpoints: `clientTests/printList/${this.employeeID}`,
        dynamic: true
      }
    },
    reportListFilename() {
      return `${this.employeeName} - Client Tests`
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    },

    canDelete() {
      return !(this.basicStaffRole.includes(localStorage.getItem("userRole")) || this.isAuditorRole);
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    item: {
      deep: true,
      handler() {
        if (!this.editTest) {
          this.autoSave();
        }
      },
    },
  },

  created() {
    this.getTests();
    this.item.newDate = moment().format("YYYY-MM-DD");
    this.getCompanyById();
  },

  methods: {
    initialize() {
      this.tests = [];
    },
    viewTest(item) {
      this.$router.push({
        path: `/ClientTest/${this.employeeID}/edit`,
        query: { id: item._id, new: false },
      });
    },
    showAdd() {
      this.titleForm = "New Client Test";
      this.newTest = true;
      this.editTest = false;
      this.draftKey = uuidv4();
      this.$router.push({
        path: `/ClientTest/${this.employeeID}/add`,
      });
    },

    deleteTest(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this client test?") &&
        this.testDelete(id);
    },

    testDelete(id) {
      axios.delete(`${url}/clientTests/${id}`).then((response) => {
        this.getTests();
        if (response.status == 400) {
          response.json().then(function (data) {
            return data.msg;
          });
        }
        this.msg = true;
        this.text = "The client test has been deleted successfully.";
      });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.clearData();
    },

    getTests: function () {
      this.isLoading = true;
      axios
        .get(`${url}/clientTests/${this.employeeID}`)
        .then((res) => {
          this.tests = res.data.tests;
          this.staffName = this.tests[0].Employee.Name;
          for (var i = 0; i < this.tests.length; i++) {
            this.tests[i].Date = moment(this.tests[i].Date).format(
              "YYYY-MM-DD"
            );
          }
          this.getClients();
          this.getUnits();
        })
        .finally(() => (this.isLoading = false));
    },

    getClients: function () {
      let params = {};
      let endpoint = `${url}/clients`;
      params["Company:in"] = this.userCompanyIds;

      if (
        this.userRole !== "Administration" &&
        this.userRole !== "SuperAdministrator"
      ) {
        params["State"] = this.userState;
      }
      axios.get(endpoint, { params }).then(async (res) => {
        this.clients = res.data.clients;
      });
    },

    getUnits: function () {
      axios.get(`${url}/units`).then(async (res) => {
        this.units = res.data.units;
      });
    },

    addTest: function () {
      axios.post(`${url}/clientTests`, this.clientTestData()).then((res) => {
        this.getTests();
        if (res.status == 400) {
          res.json().then(function (data) {
            this.text = data.msg;
          });
        }
        this.clearData();
        this.msg = true;
        this.text = "The new client test has been added successfully.";
      });
      this.close();
    },

    autoSave() {
      try {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
          axios
            .post(`${url}/clientTests/draft`, this.clientTestData())
            .then((res) => {
              this.getTests();
              this.snackbar = true;
              this.snackbarMsg = "Client Test Save";
              console.log(res);
            });
        }, 5000);
      } catch (error) {
        this.snackbar = false;
        console.log(error);
      }
    },

    getCompanyById() {
      axios
        .get(`${url}/companies/${this.userCompanyIds}`)
        .then((res) => {
          this.userCompany = res.data;
        })
        .catch((error) => {
          console.log(error.response.data.msg);
        });
    },
  },
};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media print {
  .hideOnPrint {
    display: none;
    border: none;
  }

  .outlined {
    outline-style: solid;
    outline-width: thin;
    border: 0.5px solid black;
    height: auto;
    padding: 5px;
  }

  nav.v-navigation-drawer,
  header.v-toolbar,
  button.v-btn,
  div.v-card {
    display: none;
    border: none;
  }

  @page {
    margin: 0;
  }
  body {
    margin: 1.6cm;
  }
}
</style>
